$(function() {

    if (jQuery('.js-select-subcategories').length) {
        jQuery('.js-select-subcategories').on(
            {
                /*
                'mousedown':function(event){
                    if (event.button == 0) {
                        var target = jQuery('.js-select-subcategories').find(':selected').attr('data-target');
                        kcGoToPage(target);
                    }
                },
                */
                'keydown' : function(event){
                    if (event.key == 'Enter') {
                        event.preventDefault();
                        var target = jQuery('.js-select-subcategories').find(':selected').attr('data-target');
                        kcGoToPage(target); 
                    } 
                } 
            }
        );
    }
})
function kcGoToPage(target){ 
    console.log(target);
    window.location.href = target;

} 